import { onError } from 'apollo-link-error'
import { Observable } from 'apollo-link'
import { refreshToken } from '@polleverywhere/fetch/lib/csrf'

export const refreshTokenLink = onError(({ graphQLErrors, networkError, operation, forward }) => {
  if (graphQLErrors) {
    for (const err of graphQLErrors) {
      if (err.type === 'InvalidAuthenticityToken') {
        // Let's refresh token through async request
        return new Observable(observer => {
          refreshToken()
            .then(token => {
              operation.setContext(({ headers = {} }) => ({
                headers: {
                  // Re-add old headers
                  ...headers,
                  // Switch out old access token for new one
                  'X-CSRF-Token': token
                }
              }))
            })
            .then(() => {
              const subscriber = {
                next: observer.next.bind(observer),
                error: observer.error.bind(observer),
                complete: observer.complete.bind(observer)
              }

              // Retry last failed request
              forward(operation).subscribe(subscriber)
            })
            .catch(error => {
              // No refresh or client token available, we force user to login
              observer.error(error)
            })
        })
      }
    }
  }
})
